import "./styles.css";
import CatalogViewer from "./components/CatalogViewer"

export default function App() {
  return (
    <div className="App">
      <CatalogViewer />
    </div>
  );
}
